import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { openLink } from '../util/utilNative';
import DataContext from '../data/DataContext';

const styles = () => ({});

function AddressSearch(props) {
  const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  const open = useDaumPostcodePopup(scriptUrl);
  const context = useContext(DataContext);
  const { setBasicInfo, classes, dispatch } = props;
  const handleComplete = (data) => {
    console.log('[SearchAddress REsult::]', data);
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    // console.log(fullAddress);
    setBasicInfo((prev) => ({
      ...prev,
      zip: data.zonecode,
      address1: fullAddress,
    }));
    dispatch();
  };

  const handleClick = (e) => {
    e.preventDefault();
    open({ onComplete: handleComplete });
    // openLink(context, "inapp", scriptUrl);
  };
  return (
    <button className={classes.modalPlainBtn} onClick={handleClick} name="addressSearch">
      주소찾기
    </button>
    // <div>
    //      <button type='button' onClick={handleClick}>주소찾기</button>
    // </div>
  );
  // return <DaumPostcodeEmbed onComplete={handleComplete} {...props} />;
}
export default withStyles(styles)(AddressSearch);
